import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { UrlConstants } from '../core/config/url-constant';


@Injectable({
  providedIn: 'root'
})
export class IviMy23SharedService {

  constructor(private http:HttpClient) { }
  vin: string | undefined;
  hlcToken: string | undefined;
  vehicleMake: string | undefined;
  subscriptionType: string | undefined;
  countryCode: string | undefined;

  isRenewal() {
    return this.subscriptionType === 'renew' ? true : false ;     
  }

  isAcura(){
    return this.vehicleMake === 'acura' ? true : false;
  }
  
  getEnrollmentDeeplinkApi(): Observable<any>{
    const dataToApiCall = {vin:this.vin, targetApp: this.vehicleMake};
      return this.http.post<any>(UrlConstants.GENERATE_ENROLLMENT_DEEPLINK, dataToApiCall);
  }
  getRenewalDeeplinkApi(): Observable<any>{
    const dataToApiCall = {vin:this.vin, targetApp: this.vehicleMake};
      return this.http.post<any>(UrlConstants.GENERATE_RENEWAL_DEEPLINK, dataToApiCall);
  }

  setDataForIVI23(sessionData: IviMy23SessionData): void {
    this.vin = sessionData.vin;
    this.hlcToken = sessionData.HLCToken;
    this.vehicleMake = sessionData.vehicleMake;
    this.subscriptionType = sessionData.subscriptionType;
    this.countryCode = sessionData.countryCode;
  }

}

export interface IviMy23SessionData {
  vin?: string;
  HLCToken?: string;
  vehicleMake?: string;
  subscriptionType?: string;
  countryCode?: string;
}
